// extracted by mini-css-extract-plugin
module.exports = {"SettingsSection":"SettingsSection_SettingsSection__t8lBX"};